import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useBranding } from '../../branding/BrandingContext';
import './CheckoutResult.css';

const CheckoutCancelled = () => {
  const navigate = useNavigate();
  const branding = useBranding();
  const isAtendabotBrand = branding?.key === 'atendabot';

  return (
    <div className="checkout-result">
      <div className="checkout-card">
        <span className="checkout-badge is-failure">
          {isAtendabotBrand ? 'Ativação cancelada' : 'Pagamento cancelado'}
        </span>
        <h1>
          {isAtendabotBrand
            ? 'Assinatura do AtendaBot não ativada'
            : 'Checkout não finalizado'}
        </h1>
        {isAtendabotBrand ? (
          <p>
            A ativação não foi concluída. Você pode tentar novamente quando quiser.
          </p>
        ) : (
          <p>
            O pagamento não foi concluído. Sua conta continua disponível e você pode
            tentar novamente pela área de Pagamentos.
          </p>
        )}
        <div className="checkout-actions">
          <button className="primary" type="button" onClick={() => navigate('/billing')}>
            Tentar novamente
          </button>
          <button className="secondary" type="button" onClick={() => navigate('/')}>
            {isAtendabotBrand ? 'Voltar ao início' : 'Voltar'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CheckoutCancelled;
